// 大屏首页 tab 切换状态管理
import { searchVillageSelectList } from '@/api/village/villageApi.js'

const state = {
	// tab 导航列表
	mapNav: [{
		name: '控制台',
		index: 0,
		villageId: null,
	}],
	// 当前选中的 tab 索引
	mapNavIndex: 0,
	// 当前选中的小区/项目信息
	currentVillage: {
		name: '控制台',
		villageId: null,
		img: '',
	},
	// 防止重复刷新的标志位（tab 切换时设置为 true）
	isTabSwitching: false,
}

const mutations = {
	// 切换 tab
	SET_MAPNAV_INDEX(state, index) {
		state.mapNavIndex = index
		state.currentVillage = state.mapNav.find(item => item.index === index) || state.currentVillage
	},
	// 更新 mapNav 列表（从接口获取后）
	SET_MAPNAV(state, navList) {
		// console.log('SET_MAPNAV mutation 被调用, navList:', navList)
		state.mapNav = [{
			name: '控制台',
			index: 0,
			villageId: null,
		}, ...navList]
		// console.log('更新后的 mapNav:', state.mapNav)
	},
	// 更新 currentVillage
	SET_CURRENT_VILLAGE(state, village) {
		state.currentVillage = village
	},
	// 设置 tab 切换标志位
	SET_TAB_SWITCHING(state, flag) {
		state.isTabSwitching = flag
	},
}

const actions = {
	// 获取小区列表并更新 mapNav
	fetchVillageList({ commit, state }, params = {}) {
		// 默认参数
		const defaultParams = {
			vVillageId: '',
			vVillageName: '',
			vAddress: '',
			vProjectId: '',
			vRemarks: '',
			iDelFlag: 0,
			permissionDeptIds: [],
			projectId: '1274183916458217472',
			...params
		}
		
		// console.log('开始获取小区列表，参数:', defaultParams)
		
		return searchVillageSelectList(defaultParams).then(res => {
			// console.log('小区列表接口返回:', res)
			const villages = []
			if (res.data && res.data.info && res.data.info.length > 0) {
				res.data.info.forEach((item, index) => {
					villages.push({
						name: item.v_village_name,
						index: index + 1,
						villageId: item.v_village_id,
						img: item.v_img_url,
					})
				})
				// console.log('格式化后的小区列表:', villages)
				commit('SET_MAPNAV', villages)
			} else {
				console.warn('接口返回的小区列表为空')
			}
			return villages
		}).catch(err => {
			console.error('获取小区列表失败:', err)
			return []
		})
	},
}

export default {
	state,
	mutations,
	actions
}
